<!--
  SettlementRates.vue
  콜봇 월 정산 · 기본 요율(/callbot/settlement/rates) — 화면 명세 3. 회사 선택이 없는 전역 화면이다.
  2026-10-27 목업(Rates.dc.html)대로 다시 짰다 — 자동 마감 요약(CloseRunSummary)은 월 정산 목록 맨 위로 옮겼다(사용자 결정 2).

  위에서부터
  1) 머리: `← 월 정산` · '기본 요율' · 한 문장 설명 · [+ 새 버전](비활성 이유는 툴팁).
  2) 상담사 번호 요금 시작 월 경고 한 줄(G-FEE-START — ~/md/front/admin-콜봇-상담사번호-추가요금-프론트요청.md B): 목록 응답
     최상위 `fee_start_warning`(call-api 1-3, 계약 묶음 9.5)이 있을 때만 그 `message` 와 두 달을 보인다. 판정은 call-api 가 하고,
     값이 null 이거나 키가 없으면(옛 call-api) 숨긴다. 저장·삭제 뒤 목록을 다시 부를 때(loadPlans) 같이 갱신된다.
  3) 이번 달에 적용되는 버전이 없으면 그 안내(버전 없음 / 가장 이른 버전이 더 늦다).
  4) 버전 탭 + 고른 버전 카드(DefaultPlanHistory — 처음에는 이번 KST 달에 적용 중인 버전. 정보 한 줄·직전 버전과 다른 점·메모·
     [수정]·[삭제]·수정 이력, 요율 표 SettlementRateCard mode 'plan' bare).
  5) 버전 규칙(세 줄).
  [새 버전]·[수정] → 편집 모달(DefaultPlanModal). 저장하면 그 버전을 고른다. 예외가 없는 병원의 금액은 이 화면 하나로 바뀐다.

  데이터: GET /api/v1/callbot/billing/default-plans({ items, cost_rates }) — 들어올 때와 쓰기(저장·삭제) 뒤에 부른다.
          API 는 getSettlementApi() 하나(?settlementMock=1 이면 목).
  돌아가기: `← 월 정산` — 쿼리 `month`(기본 지난 달 KST) + 목록이 sessionStorage 'admin.settlementListQuery' 에 둔 구분·검색·정렬.
  목(비운영 + ?settlementMock=1): 헤더 `목 데이터` 배지 안 접힌 'DEV 목 조작' — 2026-09 버전을
  요금표 v70 이전 모양으로 바꾸기(배포 직후 intest 흉내 — ~/md/front/admin-콜봇-월정산-call-api-구현회신.md
  "2026-10-16 개정" 1 `legacy: true`, [수정]에서 새 칸으로 다시 저장하면 풀린다), 목 초기화. 자동 마감 켜기·인덱스 미준비·병원 마감 상태 고르기는 결과가 보이는
  월 정산 목록의 'DEV 목 조작'에 있다.
  요청 문서: ~/md/front/admin-콜봇-월정산-프론트요청.md "화면 명세 3", "요청 계약 3-1·4-1"
-->
<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div style="margin-top: 28px"></div>

    <!-- 페이지 헤더 영역 -->
    <div class="card-header pb-0 col-sm-12 d-flex">
      <div class="col-sm-12 col-xs-12">
        <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
          <router-link class="back-link" :to="listLocation">← 월 정산</router-link>
          <div class="title-row">
            <div class="title-block">
              <div class="title-line">
                <h1 class="fw-bold page-title">기본 요율</h1>
                <!-- Sibling of the title (a block <details> must not sit inside the badge's <span>) -->
                <details v-if="mock" class="mock-dev">
                  <summary class="mock-dev__summary">
                    <SettlementMockBadge />
                    <span>DEV 목 조작</span>
                  </summary>
                  <div class="mock-dev__body" role="group" aria-label="목 데이터 조작(개발용)">
                    <a-button size="small" :title="MOCK_LEGACY_TITLE" @click="onMockLegacyPlan">v70 이전 시드</a-button>
                    <a-button size="small" @click="onMockReset">목 초기화</a-button>
                  </div>
                </details>
              </div>
              <span class="pageDesc">
                예외가 없는 모든 병원에 쓰는 요율입니다. 병원마다 다르게 받거나 내부·테스트로 두려면 그 병원 월 정산의 요율 탭에서 예외를 둡니다.
              </span>
            </div>
            <a-tooltip :title="createDisabledReason || undefined">
              <a-button type="primary" class="yellow-button" :disabled="!!createDisabledReason" @click="openCreate">
                <template #icon><PlusOutlined /></template>
                새 버전
              </a-button>
            </a-tooltip>
          </div>
        </div>
      </div>
    </div>

    <!-- 콘텐츠 영역 -->
    <div class="px-0 pb-2">
      <div class="rates-page">
        <div v-if="plansUnavailable" class="rates-page__state" role="status">
          <p>call-api 에 기본 요율 API 가 아직 없습니다(배포 전).</p>
          <p v-if="SETTLEMENT_MOCK_HINT" class="rates-page__state-hint">{{ SETTLEMENT_MOCK_HINT }}</p>
        </div>
        <div v-else-if="plansError" class="rates-page__state is-error" role="alert">
          <p>{{ plansError }}</p>
          <a-button size="small" :loading="plansLoading" @click="loadPlans">다시 시도</a-button>
        </div>
        <div v-else-if="!plansLoaded" class="rates-page__card">
          <a-skeleton active :title="false" :paragraph="{ rows: 8 }" />
        </div>

        <a-spin v-else :spinning="plansLoading" size="small">
          <div class="rates-page__body">
            <a-alert v-if="feeStartWarning" class="rates-page__banner" type="warning" show-icon>
              <template #message>
                {{ feeStartWarning.message }}<span v-if="feeStartWarning.months" class="rates-page__banner-sub">
                  · {{ feeStartWarning.months }}</span
                >
              </template>
            </a-alert>

            <a-alert v-if="!currentPlan" class="rates-page__banner" type="warning" show-icon :message="noCurrentText" />

            <DefaultPlanHistory
              v-model:selected="selectedVersion"
              :api="api"
              :plans="plans"
              :cost-rates="costRates"
              :current-month="thisMonth"
              @edit="openEdit"
              @changed="loadPlans"
            />
          </div>
        </a-spin>

        <section class="rates-page__card rates-rules" aria-labelledby="rates-rules-title">
          <h2 id="rates-rules-title" class="rates-rules__title">버전 규칙</h2>
          <ul class="rates-rules__list">
            <li>각 달에는 적용 시작 월이 그 달 이전인 버전 중 가장 최근 것을 씁니다.</li>
            <li>이미 확정된 달은 버전을 고쳐도 바뀌지 않습니다.</li>
            <li>단가를 바꿀 때는 지금 버전을 고치지 말고 다음 달 버전을 만듭니다.</li>
          </ul>
        </section>
      </div>
    </div>

    <DefaultPlanModal
      :open="modal.open"
      :api="api"
      :plans="plans"
      :cost-rates="costRates"
      :mode="modal.mode"
      :plan="modal.plan"
      :initial-month="modal.initialMonth"
      @close="closeModal"
      @saved="onSaved"
    />
  </div>
</template>

<script>
export default {
  name: 'SettlementRates',
};
</script>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { message } from 'ant-design-vue';
import { PlusOutlined } from '@ant-design/icons-vue';

import DefaultPlanHistory from './components/DefaultPlanHistory.vue';
import DefaultPlanModal from './components/DefaultPlanModal.vue';
import SettlementMockBadge from './components/SettlementMockBadge.vue';
import {
  compareMonth,
  currentMonthKst,
  isValidMonth,
  monthLabel,
  nextMonthKst,
  resolveMonthParam,
} from './service/settlementFormat';
import { effectiveDefaultPlan, feeStartWarningView, settlementListLocation } from './service/settlementRules';
import { readSavedListQuery } from './service/settlementListQuery';
import {
  SETTLEMENT_MOCK_HINT,
  getSettlementApi,
  isSettlementMockEnabled,
  settlementMockControls,
} from './service/settlementMock';
import { isCallApiUnimplemented, parseCallApiError } from '@/views/Callbot/service/callApiError';

const route = useRoute();

// API 는 들어올 때 한 번 고른다 — 목이면 같은 모양의 목(서버에 요청하지 않는다)
const mock = isSettlementMockEnabled();
const api = getSettlementApi();

/** 페이지를 연 시점의 KST 달 — "적용 중인 버전"의 기준 */
const thisMonth = currentMonthKst();

const asArray = (v) => (Array.isArray(v) ? v : []);

// ---------------------------------------------------------------------------
// 돌아갈 달 — 쿼리 `month`, 없거나 틀리면 지난 달(KST)
// ---------------------------------------------------------------------------

const month = computed(() => resolveMonthParam(route.query.month));

// 이 화면의 달 + 목록이 sessionStorage 에 남긴 구분·검색·정렬(읽지 못하면 기본 목록)
const listLocation = computed(() => settlementListLocation(month.value, readSavedListQuery()));

// ---------------------------------------------------------------------------
// 기본 요율 버전 — 늦게 온 앞 응답이 새 응답을 덮지 않게 마지막 요청만 반영한다
// ---------------------------------------------------------------------------

const plans = ref([]);
const costRates = ref(null);
/** 상담사 번호 요금 시작 월 경고(feeStartWarningView) — 목록을 받을 때마다 다시 정한다. 없으면 null(숨김) */
const feeStartWarning = ref(null);
const plansLoading = ref(false);
const plansLoaded = ref(false);
/** 받은 값이 없을 때 본문 자리에 보이는 오류 */
const plansError = ref('');
/** call-api 미배포(라우트 없음 404·501) */
const plansUnavailable = ref(false);
/** 고른 버전 탭(적용 시작 월). 비면 적용 중인 버전 — DefaultPlanHistory 가 정한다 */
const selectedVersion = ref('');
let plansSeq = 0;

async function loadPlans() {
  const my = ++plansSeq;
  plansLoading.value = true;
  try {
    const res = await api.listDefaultPlans();
    if (my !== plansSeq) return;
    plans.value = asArray(res?.items);
    costRates.value = res?.cost_rates ?? null;
    feeStartWarning.value = feeStartWarningView(res);
    plansLoaded.value = true;
    plansError.value = '';
    plansUnavailable.value = false;
  } catch (err) {
    if (my !== plansSeq) return;
    if (isCallApiUnimplemented(err)) {
      plansUnavailable.value = true;
      return;
    }
    const text = parseCallApiError(err, '기본 요율을 불러오지 못했습니다.');
    // 받아 둔 목록이 있으면 그대로 두고 알리기만 한다
    if (plansLoaded.value) message.error(text);
    else plansError.value = text;
  } finally {
    if (my === plansSeq) plansLoading.value = false;
  }
}

onMounted(() => {
  void loadPlans();
});

/** 이번 달에 적용되는 버전(적용 시작 월이 이번 달 이하인 것 중 가장 최근) */
const currentPlan = computed(() => effectiveDefaultPlan(plans.value, thisMonth));

/** 버전들의 적용 시작 월(오름차순) */
const planMonths = computed(() => plans.value.map((p) => p?.effective_from).filter(isValidMonth).sort(compareMonth));
/** 가장 이른 버전의 적용 시작 월 — 그 전 달은 기본 요율이 없다 */
const firstPlanMonth = computed(() => planMonths.value[0] ?? '');

const noCurrentText = computed(() => {
  if (!planMonths.value.length) {
    return '기본 요율 버전이 없어 모든 달이 금액을 계산하지 않고 검토 필요로 멈춥니다. [새 버전]으로 만드세요.';
  }
  return `이번 달(${monthLabel(thisMonth)})에 적용되는 버전이 없습니다. 가장 이른 버전이 ${firstPlanMonth.value}부터라 그 전 달은 금액을 계산하지 않습니다.`;
});

// ---------------------------------------------------------------------------
// 편집 모달 — [새 버전](기본 다음 달) / [수정]
// ---------------------------------------------------------------------------

const modal = reactive({ open: false, mode: 'create', plan: null, initialMonth: '' });

// 같은 달 버전이 있는지·복사할 직전 버전을 모달이 목록에서 찾으므로 목록을 받은 뒤에만 연다
const createDisabledReason = computed(() => {
  if (plansUnavailable.value) return 'call-api 에 기본 요율 API 가 아직 없습니다(배포 전).';
  if (!plansLoaded.value) return '기본 요율을 불러온 뒤 만들 수 있습니다.';
  return null;
});

function openCreate() {
  if (createDisabledReason.value) return;
  Object.assign(modal, { open: true, mode: 'create', plan: null, initialMonth: nextMonthKst() });
}

function openEdit(plan) {
  if (!plan || !isValidMonth(plan.effective_from)) return;
  Object.assign(modal, { open: true, mode: 'edit', plan, initialMonth: plan.effective_from });
}

function closeModal() {
  modal.open = false;
}

/** 저장한 버전을 고른다 — 다시 받은 목록에 그 달이 있으면 그 탭이 열린다 */
function onSaved(saved) {
  modal.open = false;
  if (isValidMonth(saved?.effective_from)) selectedVersion.value = saved.effective_from;
  void loadPlans();
}

// ---------------------------------------------------------------------------
// 목 조작(개발용) — 목이 켜졌을 때만 보인다. 자동 마감 켜기·인덱스 미준비·병원 마감 상태는 그 결과가 보이는 월 정산 목록의
// 'DEV 목 조작'에 있다(2026-10-27 자동 마감 요약을 목록으로 옮기며 이 화면에서 뺐다)
// ---------------------------------------------------------------------------

const MOCK_LEGACY_TITLE =
  '2026-09 기본 버전을 요금표 v70 이전 모양(예전 시드, legacy: true)으로 바꿉니다 — 그 버전이 적용되는 달은 금액을 계산하지 않습니다. [수정]에서 새 칸으로 다시 저장하면 풀립니다.';

function onMockLegacyPlan() {
  settlementMockControls.setLegacyDefaultPlan();
  void loadPlans();
}

function onMockReset() {
  settlementMockControls.reset();
  void loadPlans();
}
</script>

<style scoped lang="scss">
@use './styles/settlement' as *;

@include yellow-button;

.container-wrap {
  padding: 0 16px;
}

.titleContainer {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.back-link {
  align-self: flex-start;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: $st-text-secondary;
  text-decoration: none;

  &:hover {
    color: $st-accent;
  }

  &:focus-visible {
    outline: 2px solid $st-accent;
    outline-offset: 2px;
    border-radius: 4px;
  }
}

.title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  gap: 12px 16px;
}

.title-block {
  display: flex;
  flex: 1 1 420px;
  flex-direction: column;
  min-width: 0;
}

.title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
}

.page-title {
  color: #000;
  font-size: 1.8rem;
  margin-bottom: 0;
}

.pageDesc {
  color: #6c757d;
  font-size: 14px;
  margin-top: 8px;
}

// 목 조작(개발용) — 제목 옆에 접힌 채로(상세 헤더와 같은 모양)
.mock-dev {
  font-size: 12px;

  &__summary {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: $st-warning;
    cursor: pointer;
    font-weight: 600;
  }

  &__body {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 10px;
    margin-top: 6px;
    padding: 6px 10px;
    border: 1px dashed $st-warning-border;
    border-radius: 8px;
    background: #fffdf8;
  }
}

.rates-page {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__card {
    @include st-card;
  }

  &__banner-sub {
    color: $st-text-secondary;
    font-variant-numeric: tabular-nums;
  }

  &__state {
    padding: 16px;
    border: 1px dashed $st-border-strong;
    border-radius: 10px;
    background: $st-bg;
    color: $st-text-secondary;
    font-size: 13px;

    p {
      margin: 0;
    }

    &.is-error {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      border-color: $st-danger-border;
      background: $st-danger-bg;
      color: $st-danger;
    }
  }

  &__state-hint {
    margin-top: 4px !important;
    font-size: 12px;
    color: $st-muted;
  }
}

.rates-rules {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 20px;

  &__title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: $st-text;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 0;
    padding-left: 18px;
    font-size: 13.5px;
    color: $st-text-secondary;
  }
}
</style>
